/* global console setTimeout */
import React from "react";
import ReactClass from "create-react-class";

import * as _ from "lodash";

export default ReactClass({
  displayName: "GraphLegendComponent",

  handleLegendDrag(e, field) {
    this.props.onFieldMoveStart(this.props.index);
    e.dataTransfer.setData("text/plain", JSON.stringify({field, from: this.props.index}));
  },

  handleLegendDragCancel(e) {
    this.props.onFieldMoveCancel();
  },

  preventDefault: function (event) {
    event.preventDefault();
  },

  handleLegendDrop(e) {
    this.props.onFieldMoved(
      Object.assign(
        {to: this.props.index},
        JSON.parse(e.dataTransfer.getData("text/plain"))
      )
    );
  },

  // Check if a property can be removed based on dependencies
  canRemoveProperty(prop, allEntries) {
    if (!prop || !prop.name) return true;
    
    // Find other entries that depend on this property
    const dependentEntries = allEntries.filter(entry => 
      entry.prop && entry.prop.dependentField === prop.name
    );
    
    return dependentEntries.length === 0;
  },

  // Show warning when trying to remove a required property
  showDependencyWarning(prop, dependentEntries) {
    if (!dependentEntries.length) return;
    
    const dependentNames = dependentEntries
      .map(entry => entry.prop.displayName)
      .join(', ');
      
    alert(`Cannot remove "${prop.displayName}" - it is required by: ${dependentNames}`);
  },

  // Get enhanced tooltip with dependency information
  getEnhancedTooltip(entry, allEntries) {
    let tooltip = entry.label;
    
    if (entry.prop) {
      // Check if this property is required by others
      const dependentEntries = allEntries.filter(e => 
        e.prop && e.prop.dependentField === entry.prop.name
      );
      
      if (dependentEntries.length > 0) {
        const dependentNames = dependentEntries
          .map(e => e.prop.displayName)
          .join(', ');
        tooltip += `\r\n\r\n🔗 Required by: ${dependentNames}`;
        tooltip += `\r\nCannot be removed while required.`;
      }
      
      // Check if this property depends on others
      if (entry.prop.dependentField) {
        const controllingEntry = allEntries.find(e => 
          e.prop && e.prop.name === entry.prop.dependentField
        );
        if (controllingEntry) {
          tooltip += `\r\n\r\n→ Depends on: ${controllingEntry.prop.displayName}`;
        }
      }
    }
    
    return tooltip;
  },

  render: function() {
    const {config, record} = this.props,
        fields = config && config.dataSets && config.dataSets[0]
    ;

    let list = (fields && fields.fieldMappings) || [];

    list = list
      .filter(f => f.hideInLegend !== true)
      .filter(f => String(f.panelIdx) === String(this.props.index))
      .map(f => {
        return {
          id: f.prop.id,
          field: f.toField,
          event: !!f.event,
          label: f.prop ? f.prop.displayName :
              _.findKey(this.props.keyMap, key => key === f.toField),
          color: f.color,
          value: record ? record[f.toField] : "-",
          prop: f.prop // Keep full property object for dependency checks
        };
      });

    // Add dependency information to each entry
    const enhancedList = list.map(entry => ({
      ...entry,
      canRemove: this.canRemoveProperty(entry.prop, list),
      enhancedTooltip: this.getEnhancedTooltip(entry, list)
    }));

    return (
      <section className={
        `graph-legend ${this.props.index} ${this.props.droppable ? "droppable" : !enhancedList.length ? "empty" : ""} ${this.props.className}`
      }
      //style={{top: this.props.top + "%"}}
      //height of the legend is updated based on the index of the legend and selected graph panel.
      style={
        {
          top: (this.props.index == 0) ? 0 + "%" : (this.props.index !== this.props.selectedGraphPanel) ? 50 + "%" : 5 + "%",
          display: (this.props.selectedGraphPanel !== -1) ? (this.props.index == this.props.selectedGraphPanel) ? "inline" : "none" : "inline"
        }}
      >
        <table>
          <tbody>
          {!this.props.droppable ? enhancedList.map(entry => (
            <tr key={`${entry.field} ${entry.label}`} className="legend-entry" draggable="true"
                onDragStart={e => this.handleLegendDrag(e, entry.field)}
                onDragEnd={e => this.handleLegendDragCancel(e)}>
              <td onClick={() => this.props.onFieldToggle(entry.field)}>
                <i className={`color`} style={{backgroundColor: entry.color}}>
                  {entry.event === true ? "!" : ""}
                </i>
                {!entry.canRemove && <span className="lock-indicator" style={{color: '#17a2b8'}}>🔗</span>}
              </td>
              <td className="current-value">{entry.value === undefined || entry.value === null ? '' : entry.value}</td>
              <td className="label"
                  onMouseOver={() => this.props.onFieldHover(entry.field)}
                  onMouseOut={() => this.props.onFieldHover()}
                  title={entry.label}
              >
                {entry.label}
              </td>
              <td onClick={() => {
                if (entry.canRemove) {
                  // Remove the main property
                  this.props.onFieldRemove(entry);
                  
                  // Auto-remove properties that depend on this one (not the other way around)
                  // Find properties where their dependentField points to this property
                  const propertiesToAutoRemove = enhancedList.filter(e => 
                    e.prop && e.prop.dependentField === entry.prop.name
                  );
                  
                  if (propertiesToAutoRemove.length > 0) {
                    propertiesToAutoRemove.forEach(dependentEntry => {
                      console.log(`Auto-removing dependent property: ${dependentEntry.prop.displayName} when removing ${entry.prop.displayName}`);
                      // Use setTimeout to ensure the first removal is processed first
                      setTimeout(() => {
                        this.props.onFieldRemove(dependentEntry);
                      }, 10);
                    });
                  }
                } else {
                  const dependentEntries = enhancedList.filter(e => 
                    e.prop && e.prop.dependentField === entry.prop.name
                  );
                  this.showDependencyWarning(entry.prop, dependentEntries);
                }
              }}>
                <i className={`icon-x ${!entry.canRemove ? 'disabled locked' : ''}`} />
              </td>
            </tr>
          )) : (
              <tr className="legend-dropzone"
                  onDragOver={this.preventDefault}
                  onDrop={e => this.handleLegendDrop(e, this.props.index)}>
                <td>Drop here...</td>
              </tr>
          )}
          </tbody>
        </table>
      </section>
    );
  }
});
